import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CampaignReachResponseDataSchema, DataResponse, GetCampaignReachSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CampaignReachResponseDataSchema>>

const getCampaignReachQueryKey = (id: string, query?: z.input<typeof GetCampaignReachSchema>) => [
  "campaigns",
  id,
  "reach",
  query,
]

type Props = {
  id: string
  query?: z.input<typeof GetCampaignReachSchema>
  enabled?: boolean
}

export const campaignReachQuery = ({ id, query, enabled }: Props) => {
  return queryOptions({
    queryKey: getCampaignReachQueryKey(id, query),
    queryFn: async () => {
      const response = await axios.post<Response>(`/campaigns/${id}/reach`, query)
      return response.data.data
    },
    enabled,
  })
}
